import { render } from "./Stock.vue?vue&type=template&id=1ab2658c&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=js"
export * from "./Stock.vue?vue&type=script&lang=js"

import "./Stock.vue?vue&type=style&index=0&id=1ab2658c&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab2658c"]])

export default __exports__